import * as Integration from '../data-integration/types';
import {
  DataIntegrationAction,
  DataIntegrationTypes,
  initialState,
} from '../types';
import { Reducer } from 'redux';

const getIntegration: Reducer<Integration.Status, DataIntegrationAction> = (
  state: Integration.Status = initialState.integrationStatus,
  action: DataIntegrationAction,
): Integration.Status => {
  switch (action.type) {
    case DataIntegrationTypes.UPDATE_STATUS:
      return action.payload;
    case DataIntegrationTypes.UPDATE_INVITE_NEW:
      return {
        ...state,
        inviteNew: action.payload,
      };
    default:
      return state;
  }
};

export default getIntegration;
